/**
 * @providesModule Notifications.react
 */

import React from 'react';
import {AlertDanger, Alert, AlertInfo, AlertSuccess} from '@homeaway/react-alerts';
import {Button} from '@homeaway/react-buttons';
import OverlayActions from '../../../../data/Overlay/OverlayActions';
import {PropTypes} from 'prop-types';
import NotificationTypes from '../../../../modules/NotificationTypes';
import './Notifications.less';
import LocaleContext from '../../../../Contexts/Locale/Context';

export default class Notifications extends React.Component {
    static propTypes = {
        notifications: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                titleKey: PropTypes.string.isRequired,
                msgKey: PropTypes.string.isRequired,
                actions: PropTypes.arrayOf(
                    PropTypes.shape({
                        labelKey: PropTypes.string.isRequired,
                        callback: PropTypes.func.isRequired,
                    })
                ),
                type: PropTypes.oneOf([
                    NotificationTypes.warning,
                    NotificationTypes.success,
                    NotificationTypes.danger,
                    NotificationTypes.info,
                ]).isRequired,
            })
        ),
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let notifications = [];
        nextProps.notifications
            .map((notification) => ({
                // map
                key: Notifications._getNotificationCompoundKey(notification),
                value: notification,
            }))
            .reduce((result, entry) => {
                // shuffle
                let values = result.get(entry.key) || [];
                values.push(entry.value);
                result.set(entry.key, values);
                return result;
            }, new Map())
            .forEach((values, key) => {
                // reduce
                notifications.push({
                    ids: values.map((notification) => notification.id),
                    actions: values
                        .map((notification) => notification.actions)
                        .reduce(
                            (result, entry) =>
                                result.concat(
                                    entry.filter(
                                        (action) =>
                                            !result.find(
                                                (otherAction) =>
                                                    otherAction.labelKey === action.labelKey &&
                                                    otherAction.callback === action.callback
                                            )
                                    )
                                ),
                            []
                        ),
                    titleKey: values[0].titleKey,
                    count: values.length,
                    msgKey: values[0].msgKey,
                    type: values[0].type,
                });
            });

        return {
            notifications,
        };
    }

    static _getNotificationCompoundKey(notification) {
        return `${notification.titleKey} ${notification.msgKey} ${notification.type}`;
    }

    static _getNotificationContent(notification, getTranslation) {
        let title = getTranslation('messages', notification.titleKey);
        let msg = getTranslation('messages', notification.msgKey);
        return [
            <p key="title">
                <strong>{title}</strong>
                {notification.count > 1 && (
                    <strong>
                        <i>{` (${notification.count})`}</i>
                    </strong>
                )}
            </p>,
            <p key="message">{msg}</p>,
        ].concat(
            notification.actions.map((action) => (
                <Button
                    key={action.labelKey}
                    label={getTranslation('messages', action.labelKey)}
                    onClick={action.callback}
                />
            ))
        );
    }

    render() {
        let notifications = this.state.notifications;
        return (
            <div className="notifications">
                <LocaleContext.Consumer>
                    {(getTranslation) => (
                        <div className="notifications-container">
                            <div className={'alerts'}>
                                {notifications.map((notification) => {
                                    let alert;
                                    let alertContent = Notifications._getNotificationContent(
                                        notification,
                                        getTranslation
                                    );
                                    let notificationProps = {
                                        key: notification.ids,
                                        dismissible: true,
                                        onAlertClosed: () =>
                                            OverlayActions.removeNotifications(notification.ids),
                                    };
                                    switch (notification.type) {
                                        case NotificationTypes.warning:
                                            alert = (
                                                <Alert {...notificationProps}>
                                                    {' '}
                                                    {alertContent}{' '}
                                                </Alert>
                                            );
                                            break;
                                        case NotificationTypes.success:
                                            alert = (
                                                <AlertSuccess {...notificationProps}>
                                                    {alertContent}
                                                </AlertSuccess>
                                            );
                                            break;
                                        case NotificationTypes.danger:
                                            alert = (
                                                <AlertDanger {...notificationProps}>
                                                    {alertContent}
                                                </AlertDanger>
                                            );
                                            break;
                                        case NotificationTypes.info:
                                            alert = (
                                                <AlertInfo {...notificationProps}>
                                                    {alertContent}
                                                </AlertInfo>
                                            );
                                            break;
                                        default:
                                            alert = null;
                                    }
                                    return alert;
                                })}
                            </div>
                        </div>
                    )}
                </LocaleContext.Consumer>
            </div>
        );
    }
}
